import { IconProps } from './icons-props';

function ProgramIcon({ className, width = 15, height = 15 }: IconProps) {
    return (
        <svg
            fill='none'
            width={width}
            height={height}
            className={className}
            viewBox='0 0 95 96'
            xmlns='http://www.w3.org/2000/svg'
        >
            <ellipse cx='47.4999' cy='48' rx='47.2836' ry='48' fill='#EDEDFF' />
            <circle cx='47.5' cy='47.2834' r='36.5373' fill='#D6D6FF' />
            <path
                d='M54.6568 30.5015H40.3409C34.1226 30.5015 30.4155 34.299 30.4155 40.669V55.334C30.4155 61.704 34.1226 65.5015 40.3409 65.5015H54.6568C60.8751 65.5015 64.5822 61.704 64.5822 55.334V40.669C64.5822 34.299 60.8751 30.5015 54.6568 30.5015ZM44.0309 53.0765L40.1872 57.014C39.9309 57.2765 39.6064 57.399 39.2818 57.399C38.9572 57.399 38.6155 57.2765 38.3764 57.014L37.0951 55.7015C36.5826 55.194 36.5826 54.354 37.0951 53.8465C37.5905 53.339 38.3934 53.339 38.9059 53.8465L39.2818 54.2315L42.2201 51.2215C42.7155 50.714 43.5184 50.714 44.0309 51.2215C44.5264 51.729 44.5264 52.569 44.0309 53.0765ZM44.0309 40.8265L40.1872 44.764C39.9309 45.0265 39.6064 45.149 39.2818 45.149C38.9572 45.149 38.6155 45.0265 38.3764 44.764L37.0951 43.4515C36.5826 42.944 36.5826 42.104 37.0951 41.5965C37.5905 41.089 38.3934 41.089 38.9059 41.5965L39.2818 41.9815L42.2201 38.9715C42.7155 38.464 43.5184 38.464 44.0309 38.9715C44.5264 39.479 44.5264 40.319 44.0309 40.8265ZM56.9972 56.0865H48.0284C47.328 56.0865 46.7472 55.4915 46.7472 54.774C46.7472 54.0565 47.328 53.4615 48.0284 53.4615H56.9972C57.7147 53.4615 58.2784 54.0565 58.2784 54.774C58.2784 55.4915 57.7147 56.0865 56.9972 56.0865ZM56.9972 43.8365H48.0284C47.328 43.8365 46.7472 43.2415 46.7472 42.524C46.7472 41.8065 47.328 41.2115 48.0284 41.2115H56.9972C57.7147 41.2115 58.2784 41.8065 58.2784 42.524C58.2784 43.2415 57.7147 43.8365 56.9972 43.8365Z'
                fill='#6262BE'
            />
        </svg>
    );
}

export default ProgramIcon;

